<div class="padding">
  <div>
    <div class="header">{{ 'addEdit_account' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="create()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <mat-form-field appearance="fill">
        <mat-label>{{ 'account_name' | translate }}</mat-label>
        <input type="text" name="account_name" matInput #account_name="ngModel" placeholder="Account Name" required
          [(ngModel)]="account.account_name" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="5" maxlength="50">
        <mat-hint>Minimum characters 5, {{account.account_name == null ? 0 : account.account_name?.length}}/50
          Characters</mat-hint>
        <mat-error *ngIf="account_name.hasError('required')">{{ 'accountName_required' | translate }}</mat-error>
        <mat-error *ngIf="account_name.hasError('minlength')">{{ 'accountName_minLength' | translate }}</mat-error>
        <mat-error *ngIf="account_name.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'account_id' | translate }}</mat-label>
        <input type="text" name="account_id" matInput #account_id="ngModel" placeholder="Account ID" required
          [(ngModel)]="account.account_id" pattern="^[0-9A-Fa-f\-]{36}$" minlength="36" maxlength="36">
        <mat-hint>Minimum characters 36, {{account.account_id == null ? 0 : account.account_id?.length}}/36
          Characters</mat-hint>
        <mat-error *ngIf="account_id.hasError('required')">{{ 'accountId_required' | translate }}</mat-error>
        <mat-error *ngIf="account_id.hasError('minlength')">{{ 'accountId_minLength' | translate }}</mat-error>
        <mat-error *ngIf="account_id.hasError('pattern')">{{ 'charactersGuid_allowed' | translate }}</mat-error>
      </mat-form-field>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate }}</button>
      </div>

    </div>
  </form>

</div>